var _Circle, _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
function SvgMobileTrips(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    stroke: "#98A1BD",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 12,
    cy: 11,
    r: 3,
    fill: "#98A1BD"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.657 16.657L13.414 20.9a2 2 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0v0z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgMobileTrips;